import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from 'primereact/button';
import { DashboardMessageDto } from '../../api/_generated_';

type Props = {
  data?: DashboardMessageDto[];
  onArchive?: (item: DashboardMessageDto) => void;
  onMarkAsRead?: (item: DashboardMessageDto) => void;
};

export default function DashboardMessages({ data, onArchive, onMarkAsRead }: Props) {
  const { t } = useTranslation();

  if (data?.length === 0) {
    return <span>{t('summary.label-no-new-messages')}</span>;
  }

  return (
    <div>
      {data?.map((message) => (
        <ListItem
          key={message.id}
          item={message}
          onArchive={onArchive}
          onMarkAsRead={onMarkAsRead}
        />
      ))}
    </div>
  );
}

type ListItemProps = {
  item: DashboardMessageDto;
  onArchive?: (item: DashboardMessageDto) => void;
  onMarkAsRead?: (item: DashboardMessageDto) => void;
};

function ListItem({ item, onArchive, onMarkAsRead }: ListItemProps) {
  const { t } = useTranslation();

  const link = item.entityType === 'offer'
    ? `/offers/messages/${item.entityId}`
    : `/products/${item.entityId}/messages`;

  let title = item.entityId;

  if (item.displayName) {
    title += ` - ${item.displayName}`;
  }

  return (
    <div
      key={item.id}
      className="dashboard-list-item"
    >
      <div>
        <Link to={link}>
          <span className={item.read ? '' : 'highlighted'}>{title}</span>
        </Link>
        <span className="secondary-text">
          { (item.body && item.body.length > 50)
            ? `${item.body?.substring(0, 50)}...`
            : item.body}
        </span>
      </div>
      <div>
        {!item.read && (
          <Button
            icon="pi pi-check"
            rounded
            text
            size="small"
            onClick={() => onMarkAsRead?.(item)}
            tooltip={t('summary.tooltip.markAsRead')}
            tooltipOptions={{ position: 'top' }}
          />
        )}
        <Button
          icon="pi pi-inbox"
          rounded
          text
          size="small"
          onClick={() => onArchive?.(item)}
          tooltip={t('summary.tooltip.archive')}
          tooltipOptions={{ position: 'top' }}
        />
      </div>
    </div>
  );
}
